import $ from 'jquery'

/**
 * 将对象属性值转为map结构
 * @param {*} obj
 */
export function objToMap (obj) {
  let map = new Map()
  for (let key of Object.keys(obj)) {
    map.set(key, obj[key])
  }
  return map
}

/**
 * 将对象数组拆分为 key-val数组
 * @param {*} obj
 */
export function objToKeyVal (obj) {
  let arr = []
  for (let key of Object.keys(obj)) {
    let obj_ = {}
    obj_['key'] = key
    obj_['val'] = obj[key]
    arr.push(obj_)
  }
  return arr
}

/**
 * 分页
 */
export function pagination (page, pageSize, all) {
  let begin = ((page - 1) * pageSize)
  let end = begin + pageSize
  return all.slice(begin, end)
}

/**
 * 更改排序
 */
export function sortChange (obj, all) {
  let _p = obj.prop
  let isReverse = (obj.order === 'descending')
  all.sort((a, b) => {
    let _a = a[_p]
    let _b = b[_p]
    if (!isNaN(_a)) {
      _a = Number(_a)
      _b = Number(_b)
    }
    if (_a < _b) return isReverse ? 1 : -1
    if (_a > _b) return isReverse ? -1 : 1
    return 0
  })
}

export function download (url, options) {
  let form = $('<form>')
  form.attr('style', 'display:none')
  form.attr('target', '')
  form.attr('method', 'post')
  form.attr('action', url)
  let tokenInput = $('<input>')
  let typeInput = $('<input>')
  tokenInput.attr('type', 'hidden')
  tokenInput.attr('name', 'token')
  tokenInput.attr('value', localStorage.getItem('default_auth_token'))
  typeInput.attr('type', 'hidden')
  typeInput.attr('name', 'options')
  typeInput.attr('value', JSON.stringify(options))
  $('body').append(form)
  form.append(tokenInput)
  form.append(typeInput)
  form.submit()
}

export function downloadForGet (url) {
  if (url.indexOf('?') === -1) {
    location.href = url + '?token=' + localStorage.getItem('default_auth_token')
  } else {
    location.href = url + '&token=' + localStorage.getItem('default_auth_token')
  }
}

/**
 *
 * @param {yyyy-mm-dd} from
 * @param {yyyy-mm-dd} to
 */
export function calcDays (from, to) {
  return Math.abs((Date.parse(from) - Date.parse(to)) / 1000 / 60 / 60 / 24) + 1
}



// WEBPACK FOOTER //
// ./src/common/js/common-utils.js